import * as types from './constants';

// Publish Assignment
export const publishAssignmentRequest = data => (
  { type: types.PUBLISH_ASSIGNMENT_REQUEST, payload: data }
);

export const publishAssignmentDone = data => (
  { type: types.PUBLISH_ASSIGNMENT_DONE, payload: data }
);

export const publishAssignmentFailed = errors => (
  { type: types.PUBLISH_ASSIGNMENT_FAILED, payload: errors }
);

export const publishAssignmentClearErrors = prop => (
  { type: types.PUBLISH_ASSIGNMENT_CLEAR_ERRORS, payload: prop }
);

export const publishAssignmentReset = () => (
  { type: types.PUBLISH_ASSIGNMENT_RESET }
);